import api from "@/api/api-config";

export async function importTaxes(file) {
  let formData = new FormData();
  formData.append("file", file);
  return await api.post("taxes/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function getByDriver(userId, page = 1, pageSize = 10) {
  return await api.get(`taxes/${userId}?page=${page}&pageSize=${pageSize}`);
}

export async function getTemplate() {
  return await api.get("taxes/template", { responseType: "blob" });
}

export async function getShowTaxes(userId) {
  return await api.get(`taxes/${userId}?page=1&pageSize=1`);
}
